export default __webpack_public_path__ + "static/17-14e77375c8e12847d6eaa27d30f92b0b.jpg";